import { DonorNote } from 'modules/reports/types';

export const formatDonorNotes = (notes: DonorNote[]): string => {
  if (!notes?.length) {
    return '';
  }

  return notes
    .map((note) => `${note.user?.lastName || ''}- ${note.text}`)
    .join('| ');
};
